import { ProductQuery } from '@/graphql'

export type DescriptionProps = {
  data: ProductQuery | undefined
}

export enum DescriptionVariant {
  HEADER = 'header',
  QUOTE = 'quote',
  PARAGRAPH = 'paragraph',
  DELIMITER = 'delimiter',
  LIST = 'list',
  CHECKLIST = 'checklist',
}

type ListItem =
  | {
      text: string
      checked: boolean
    }
  | string

export type DescriptionType = {
  id: string
  type: string
  data: {
    text: string
    level?: number
    items?: ListItem[]
  }
}
